'use client'

import { ForwardedRef, forwardRef } from 'react'

import { PktHeaderService } from './HeaderService'
import { IPktHeader } from './types'

export * from './types'

/**
 * PktHeader - Main header component for Oslo kommune services
 *
 * This component provides a complete header solution with:
 * - Logo and service name
 * - User menu with login/logout functionality
 * - Search functionality
 * - Responsive mobile menu
 * - Fixed positioning with scroll-to-hide
 *
 * TODO: Add `type` prop to switch between `service` and `global` header types
 */
export const PktHeader = forwardRef((props: IPktHeader, ref: ForwardedRef<HTMLDivElement>) => {
  return <PktHeaderService {...props} ref={ref} />
})

PktHeader.displayName = 'PktHeader'
